<!-- Display the error content if an error exists. -->
@if (!!error) {

  <!-- Define the card for our error page card. -->
  <mat-card class="mat-page-card">

    <!-- Define the header for our error page card. -->
    <mat-card-header>

      <!-- Give our page an icon. -->
      <mat-icon mat-card-avatar color="warn">{{ error.icon ?? 'report' }}</mat-icon>

      <!-- Give our page a main title. -->
      <mat-card-title>Oops! It looks like an error occurred.</mat-card-title>

      <!-- Give our page a very short description. -->
      <mat-card-subtitle><strong>{{ error.code }}</strong> - {{ error.summary ?? 'Something went wrong.' }}
      </mat-card-subtitle>
    </mat-card-header>

    <!-- Define the content of our error page card. -->
    <mat-card-content class="error-container">

      <!-- Display the error message. -->
      <p [innerHtml]="error.message"></p>

      <!-- Display the error trace if it exists. -->
      @if (error.trace.length && !isProduction()) {
        <pre class="code-highlighting" [innerHTML]="error.trace.join('\n')"></pre>
      }
    </mat-card-content>
  </mat-card>

} @else {

  <!-- Display the page content if there is no error. -->
  <ng-content></ng-content>
}
